<template>
  <div id="app">
    <!-- <router-view :key="key" /> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view :key="key" v-if="!$route.meta.keepAlive"></router-view>

    <el-nav v-show="isHide"></el-nav>
  </div>
</template>
<script>
import { mapState } from "vuex";
import elNav from "@/components/nav/nav.vue";
// import { getToken } from '@/utils/auth'
export default {
  components: {
    elNav,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      isHide: (state) => state.navHide.isHide,
    }),
    key() {
      return this.$route.path + Math.random();
      // return this.$route.name !== undefined ? this.$route.name + +new Date(): this.$route + +new Date()
    },
  },
  mounted() {
    let _this = this;
    let openId = Lockr.get("openId");
    // || hold.storage.get("openId")
    if (openId == "" || openId == undefined || openId == null) return;
    if (openId) {
      setTimeout(() => {
        _this.getUserInfo();
      },1000);
    }
  },
  methods: {},
  watch: {},
};
</script>

<style lang="scss">
@import "@/styles/index.scss";
@import "@/styles/vant_edit.scss";
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  position: relative;
  height: 100%;
  // overflow: hidden;
}
.container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  // padding-bottom: 100px;
}
.van-list__loading {
  width: 100%;
}
</style>
